import { useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import LoginPanel from "../Login/LoginPanel";

import Home from "../Home";
import Pricing from "../Pricing";
import About from "../About";
import Login from "../Login";

import "./UnauthedContent.css";
import EmailVerificationDeeplinkLanding from "../EmailVerificationDeeplink";

const UnauthedContent = (props) => {
  const dispatch = useDispatch();
  const { onLogin, page, emailVerificationToken, email } = props;
  const UnauthedContentPage = useMemo(() => {
    if (page === "login") return () => <Login />;
    if (page === "pricing") return () => <Pricing />;
    if (page === "about") return () => <About />;
    if (emailVerificationToken)
      return () => (
        <EmailVerificationDeeplinkLanding email={email} token={emailVerificationToken} />
      );
    return () => <Home />;
  }, [page, onLogin, emailVerificationToken, email]);
  return (
    <div className="unauthed-content-container">
      <UnauthedContentPage />
    </div>
  );
};

export default UnauthedContent;
